import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb2"
import { useParams } from "react-router-dom"
import classnames from "classnames"
import HubUserFormBasic from "./HubUserFormBasic"
import HubUsersFormCelf from "./HubUsersFormCelf"
import { useDispatch, useSelector } from "react-redux"
import {
  editUser,
  editUserClean,
  getGroups,
  getProfiles,
  getUser,
  getUserClean,
} from "store/actions"
import HubUsersFormSoftSkills from "./HubUsersFormSoftSkills"
import SweetAlert from "react-bootstrap-sweetalert"

const HubUsersEdit = props => {
  const { id } = useParams()

  const { user, whoIAm, whoIAmNew, update, editUserError } = useSelector(
    state => ({
      user: state.UserEdit.user,
      update: state.UserEdit.updateDone,
      whoIAm: state.Profile.user,
      whoIAmNew: state.ProfileNew.user,
      editUserError: state.UserEdit.error,
    })
  )

  const userId = whoIAm?.idUsuario ?? 0
  const celfProfileId = whoIAmNew?.profileId ?? 0
  const cmoProfileId = whoIAmNew?.cmoProfileId ?? 0
  const softskillsProfileId = whoIAmNew?.softskillsProfileId ?? 0

  const canUseCelf = celfProfileId !== 8
  const canUseCmo =
    cmoProfileId === 1 ||
    cmoProfileId === 2 ||
    cmoProfileId === 5 ||
    cmoProfileId === 7
  const canUseSoftskills = softskillsProfileId === 1

  const [userInfo, setUserInfo] = useState({})
  const [activeTab, setActiveTab] = useState("0")
  const [finish, setFinish] = useState(false)
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getProfiles())
    if (userId !== 0) {
      dispatch(getGroups(userId))
    }
    dispatch(getUser(id))
    return () => {
      dispatch(getUserClean())
      dispatch(editUserClean())
    }
  }, [id])

  useEffect(() => {
    if (user) {
      setUserInfo({
        ...user,
        idUsuario: user.userId,
        userId: userId,
      })
    }
  }, [user, userId])

  useEffect(() => {
    console.log("userInfo", userInfo)
    if (finish) {
      setFinish(false)
      saveUser()
    }
  }, [userInfo, finish])

  const toggleIconCustom = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
    }
  }

  const saveUser = () => {
    setLoading(true)
    const data = {
      userId: userId,
      idUsuario: userInfo.idUsuario,
      nombre: userInfo.firstName,
      apellido: userInfo.lastName,
      email: userInfo.email,
      idRol: userInfo.profileId,
      idGrupo: userInfo.groupId,
      returnUri: userInfo.returnUri,
      idPosicion: userInfo.positionId,
      idUserN4assigned: userInfo.n4Assigned,
      idUserN5assigned: userInfo.n5Assigned,
      idUserN6assigned: userInfo.n6Assigned,
      idhCliente: userInfo.idh,
      nombreCliente: userInfo.clientName,
      softskillsProfileId: userInfo.softskillsProfileId,
      softskillsRegionId: userInfo.softskillsRegionId,
      softskillsPositionId: userInfo.softskillsPositionId,
    }
    console.log("data", data)
    dispatch(editUser(data))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Editar usuario | La Academia Fester</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col sm={4}>
              <h4>Editar usuario</h4>
            </Col>
            <Col sm={8}>
              <Breadcrumbs
                breadcrumbItems={[
                  { key: "laf", title: "La Academia Fester", link: "/start" },
                  {
                    key: "users",
                    title: "Usuarios",
                    link: "/start/adm-usuarios",
                  },
                  { key: "edit_user", title: "Editar usuario" },
                ]}
              />
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Nav className="icon-tab nav-justified">
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "0",
                        })}
                        onClick={() => {
                          toggleIconCustom("0")
                        }}
                      >
                        <span className="">
                          <i className="fas fa-box"></i> Información básica
                        </span>
                      </NavLink>
                    </NavItem>
                    {canUseCelf && (
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: activeTab === "1",
                          })}
                          onClick={() => {
                            toggleIconCustom("1")
                          }}
                        >
                          <span className="">
                            <i className="fas fa-box"></i> CELF
                          </span>
                        </NavLink>
                      </NavItem>
                    )}
                    {canUseCmo && (
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: activeTab === "2",
                          })}
                          onClick={() => {
                            toggleIconCustom("2")
                          }}
                        >
                          <span className="">
                            <i className="fas fa-box"></i> CMO
                          </span>
                        </NavLink>
                      </NavItem>
                    )}
                    {canUseSoftskills && (
                      <NavItem>
                        <NavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: activeTab === "3",
                          })}
                          onClick={() => {
                            toggleIconCustom("3")
                          }}
                        >
                          <span className="">
                            <i className="fas fa-box"></i> Softskills
                          </span>
                        </NavLink>
                      </NavItem>
                    )}
                  </Nav>
                  <TabContent
                    activeTab={activeTab}
                    className="p-3 text-muted mt-4"
                  >
                    <TabPane tabId="0">
                      <HubUserFormBasic
                        insert={false}
                        onConfirm={data => {
                          setUserInfo({
                            ...userInfo,
                            ...data,
                          })
                          if (canUseCelf) {
                            toggleIconCustom("1")
                          } else if (canUseCmo) {
                            toggleIconCustom("2")
                          } else if (canUseSoftskills) {
                            toggleIconCustom("3")
                          } else {
                            setFinish(true)
                          }
                        }}
                      />
                    </TabPane>
                    <TabPane tabId="1">
                      <HubUsersFormCelf
                        insert={false}
                        user={userInfo}
                        onConfirm={data => {
                          setUserInfo({
                            ...userInfo,
                            ...data,
                          })
                          if (canUseCmo) {
                            toggleIconCustom("2")
                          } else if (canUseSoftskills) {
                            toggleIconCustom("3")
                          } else {
                            setFinish(true)
                          }
                        }}
                        onCancel={() => {
                          toggleIconCustom("0")
                        }}
                      />
                    </TabPane>
                    <TabPane tabId="2">
                      <HubUsersFormCelf
                        insert={false}
                        user={userInfo}
                        onConfirm={data => {
                          setUserInfo({
                            ...userInfo,
                            ...data,
                          })
                          if (canUseSoftskills) {
                            toggleIconCustom("3")
                          } else {
                            setFinish(true)
                          }
                        }}
                        onCancel={() => {
                          if (canUseCelf) {
                            toggleIconCustom("1")
                          } else {
                            toggleIconCustom("0")
                          }
                        }}
                      />
                    </TabPane>
                    <TabPane tabId="3">
                      <HubUsersFormSoftSkills
                        insert={false}
                        user={userInfo}
                        onConfirm={data => {
                          setUserInfo({
                            ...userInfo,
                            ...data,
                          })
                          setFinish(true)
                        }}
                        onCancel={() => {
                          if (canUseCmo) {
                            toggleIconCustom("2")
                          } else if (canUseCelf) {
                            toggleIconCustom("1")
                          } else {
                            toggleIconCustom("0")
                          }
                        }}
                      />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {update && editUserError === "" && (
          <SweetAlert
            title="Usuario modificado exitosamente"
            success
            confirmBtnBsStyle="success"
            onConfirm={() => {
              dispatch(editUserClean())
              props.history.push("/start/adm-usuarios")
            }}
          >
            <p>El usuario ha sido modificado exitosamente.</p>
          </SweetAlert>
        )}
      </div>
    </React.Fragment>
  )
}

HubUsersEdit.propTypes = {
  history: PropTypes.object,
}

export default withRouter(HubUsersEdit)
